import { QueryClient } from '@tanstack/react-query';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import { Decorators } from './Decorators';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <Decorators queryClient={queryClient} unbranded />
  </StrictMode>
);
